import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select from 'components/Select';
import { t } from 'utils/getLiteral';
import Base from './Base';
import { ImageRow, ThreeRow, TwoRow } from './rows';

class Fuzzy extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            shouldLoad: false,
            open: false,
        };
    }

    formatOptionLabel = (item, info) => {
        const { list, formatOptionLabel } = this.props;

        if (info.context === 'value') return item.label;
        if (formatOptionLabel) return formatOptionLabel(item);

        const id = item.value;
        let option = item.label;
        const extraInfo = item.ExtraInfo && item.ExtraInfo !== '' ? item.ExtraInfo : '-';
        // const extraInfo2 = item.ExtraInfo2 && item.ExtraInfo2 !== '' ? item.ExtraInfo2 : '-';
        const extraInfo3 = item.ExtraInfo3 && item.ExtraInfo3 !== '' ? item.ExtraInfo3 : '-';

        switch (list) {
            case 'companies':
            case 'empresas':
            case 'expedientes':
            case 'contacts':
            case 'contactos':
                option = (
                    <ThreeRow
                        key={id}
                        label={item.label}
                        subLabel={extraInfo}
                        subSubLabel={extraInfo3}
                    />
                );
                break;
            case 'productos':
            case 'products':
                option = <TwoRow key={id} label={item.label} subLabel={extraInfo} />;
                break;
            case 'usuarios':
            case 'users':
                option = <ImageRow key={id} id={item.value} label={item.label} />;
                break;
            default:
                option = item.label;
        }
        return option;
    };

    handleLoadOptionsOnFocus = () => {
        const { entityLogName, logEvent } = this.props;
        entityLogName &&
            logEvent &&
            logEvent({
                event: entityLogName,
                functionality: 'search',
            });
        this.setState({
            shouldLoad: true,
            open: true,
        });
    };

    handleLoadOptionsOnBlur = () => {
        this.setState({
            shouldLoad: false,
            open: false,
        });
    };

    onChange = (item, info) => {
        const { onChange = () => null } = this.props;
        if (!onChange) return;

        if (info.action === 'clear') onChange(null);
        else if (info.action === 'select-option') {
            onChange(item);
            this.setState({
                shouldLoad: false,
                open: false,
            });
        }
    };

    renderError = () => {
        const { error } = this.props;

        if (!error || typeof error === 'object') return null;
        return <div className="fm-field-error">{error}</div>;
    };

    render() {
        const { shouldLoad, open } = this.state;
        const {
            label,
            className = '',
            hint = '',
            hidden,
            onChange = () => null,
            value,
            options = [],
            mandatory,
            description = '',
            error,
            labelMode = '',
            isClearable = true,
            disabled,
            readOnly,
            isBulkAction,
            children,
            onClickBulkEditable,
            loadOptions = () => null,
            defaultOptions = true,
            ...props
        } = this.props;

        if (hidden) return null;
        let classes = ['fm-field-fuzzy'];
        if (className) classes = [...classes, className];

        return (
            <div className={classes.join(' ')}>
                <Base
                    label={label}
                    mandatory={mandatory}
                    description={description}
                    labelMode={labelMode}
                    isBulkAction={isBulkAction}
                    onReset={onChange}
                    onClickBulkEditable={onClickBulkEditable}
                >
                    <Select
                        onFocus={this.handleLoadOptionsOnFocus}
                        onBlur={this.handleLoadOptionsOnBlur}
                        onChange={this.onChange}
                        options={options}
                        placeholder={hint || t('label_selectone')}
                        value={value}
                        isClearable={isClearable}
                        isDisabled={disabled || readOnly}
                        {...props}
                        isAsync
                        cacheOptions
                        defaultOptions={defaultOptions}
                        loadOptions={shouldLoad ? loadOptions : null}
                        menuIsOpen={open}
                        autoFocus={open}
                        formatOptionLabel={this.formatOptionLabel}
                    />
                    {children}
                    {this.renderError()}
                </Base>
            </div>
        );
    }
}

Fuzzy.propTypes = {
    label: PropTypes.string,
    hint: PropTypes.string,
    onRemove: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.shape({}),
    className: PropTypes.string,
    error: PropTypes.shape({}),
    mandatory: PropTypes.bool,
    readOnly: PropTypes.bool,
    hidden: PropTypes.bool,
    description: PropTypes.string,
    list: PropTypes.string,
    labelMode: PropTypes.string,
    onFetchOptions: PropTypes.func, // Custom load options
    formatOptionLabel: PropTypes.func,
    loadOptions: PropTypes.func,
    parentValue: PropTypes.shape({}),
    defaultOptions: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.object),
    isClearable: PropTypes.bool,
    disabled: PropTypes.bool,
    isBulkAction: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    onClickBulkEditable: PropTypes.func,
};

export default Fuzzy;
